import React from 'react';
import PropTypes from 'prop-types';
import "./Popup.css"

function Popup({ trigger, children, onClose }) {
    const handleClose = () => {
        onClose && onClose();
    };

    return trigger ? (
        <div className="popup" onClick={handleClose}>
            <div className="popup-inner" onClick={(event) => event.stopPropagation()}>
                <div className="close-btn" onClick={handleClose}>
                &times;
                </div>

                {children}
            </div>
        </div>
    ) : null;
}

Popup.propTypes = {
    trigger: PropTypes.bool,
    children: PropTypes.node,
    onClose: PropTypes.func,
  };

export default Popup;